<template lang="pug">
section.main(:class="collapsed ? 'wide' : 'narrow'")
  Header(ref="header")
  Menu
  section.page.people(ref="page",v-if="$auth.isAuthenticated && currentUser")
    b-navbar.title
      b-navbar-brand
        i.icon.fas.fa-users
        span {{ page.title }}
        template(v-if="currentUser && currentUser.acl && currentUser.acl.peoples && currentUser.acl.peoples.patch")
          span.mx-2 /
          a(:href="`/${$route.params.directory}/people/edit/${datum._id}`")
            span 候補者情報
            small
              span.ml-1 (
              i.fas.fa-user-edit.ml-1
              span 編集する
              span.ml-1 )
      b-navbar-nav.ml-auto
        b-nav-item
          b-button(variant="link",@click="onClose()") 一覧へ戻る

    section.body(ref="body",v-if="datum._id")
      b-container(fluid)
        b-row.mt-3.mb-2
          b-col
            b-container.border.rounded.bg-white(fluid)
              b-row.my-3
                b-col(cols=8)
                  b-row
                    b-col
                      .d-flex.mb-2
                        .id.mr-3 候補者ID: {{`${datum._id}`}}
                        .at 応募日: {{`${formatDay(datum.appliedAt)}`}}
                      .d-flex
                        .profile
                          span.h3.name.mb-0 {{`${datum.lastName} ${datum.firstName}`}}
                          span.splitter.mx-2
                          template(v-if="datum.lastKana || datum.firstKana")
                            span.kana {{`${datum.lastKana ? datum.lastKana : '-'} ${datum.firstKana ? datum.firstKana : '-'}`}}
                            span.splitter.mx-2 /
                          span.gender {{`${getGender(datum.gender)}`}}
                          template(v-if="datum.birthday || datum.birthYear")
                            span.splitter.mx-2 /
                            template(v-if="datum.birthday")
                              span.age {{`${getAge(datum.birthday)}`}}歳
                            template(v-else)
                              template(v-if="datum.birthYear && datum.birthMonth")
                                span.age {{`${getAge(datum.birthYear + '-' + datum.birthMonth + '-01')}`}}歳
                              template(v-else)
                                span.age {{`${getAge(datum.birthYear + '-01-01')}`}}歳
                          //-b-button.p-0.ml-3(v-if="currentUser && currentUser.acl && currentUser.acl.peoples && currentUser.acl.peoples.patch",variant="link",@click="onEdit()")
                            i.icon.fas.fa-user-edit
                            span.ml-1 編集する
                  b-row
                    b-col.mt-3
                      .d-flex.mb-2
                        b-badge.job.mr-2(v-if="datum.Job",pill,variant="light") ポジション: {{datum.Job.name}}
                        b-badge.route.mr-2(v-if="datum.Route",pill,variant="light") 応募ルート: {{datum.Route.name}}

                b-col.d-flex.flex-column.align-items-center.justify-content-center(cols=4)
                  .d-flex.flex-column
                    template(v-if="currentUser.role !== 'agent'")
                      //-.label 現在のステータス
                      template(v-if="datum.kept")
                        b-button.unclickable.kept(pill,variant="secondary") 保留
                        .label.text-center.mt-2(v-if="(!datum.status || datum.status === '' || datum.status === 'unevaluated' || datum.status === 'undecided') && (currentUser.role === 'admin' || currentUser.role === 'master' || datum.isUpdatableResult)")
                          b-button.m-0.p-0(variant="link",v-if="currentUser.role !== 'agent' && currentUser.role !== 'consultant'",@click="onKeepOff") 選考の保留を解除する
                      template(v-else)
                        b-button.unclickable.null(pill,variant="primary",v-if="!datum.status || datum.status === ''") 書類選考官の設定待ち
                        b-button.unclickable.unevaluated(pill,variant="primary",v-if="datum.status === 'unevaluated' && formatDay(datum.nextScreeningDate) <= formatDay()") 選考結果入力待ち
                        b-button.unclickable.scheduled(pill,variant="primary",v-if="datum.status === 'unevaluated' && formatDay(datum.nextScreeningDate) > formatDay()") 次回選考設定済み
                        b-button.unclickable.undecided(pill,variant="primary",v-if="datum.status === 'undecided'") 次回選考ステップ設定待ち
                        b-button.unclickable.offer(pill,variant="secondary",v-if="datum.status === 'offer' && !datum.employed") 内定
                        b-button.unclickable.employ(pill,variant="secondary",v-if="datum.status === 'offer' && datum.employed") 入社決定
                        b-button.unclickable.failure(pill,variant="secondary",v-if="datum.status === 'failure'") 選考終了
                        .label.text-center.mt-2(v-if="(!datum.status || datum.status === '' || datum.status === 'undecided' || datum.status === 'unevaluated') && (currentUser.role === 'admin' || currentUser.role === 'master' || datum.isUpdatableResult)")
                          b-button.m-0.p-0(variant="link",v-if="currentUser.role !== 'agent' && currentUser.role !== 'consultant'",@click="onKeep") 選考を保留にする
                      .label.text-center.mt-2(v-else,v-if="datum.status === 'failure' && datum.Results && datum.Results.length > 0")
                        template(v-for="(result, index) in datum.Results")
                          template(v-if="index == datum.Results.length - 1")
                            span(v-if="result.result === 'fail'") 不合格
                            span(v-if="result.result === 'decline'") 辞退
                            span(v-if="result.result === 'terminate'") 選考終了
                            //-span(v-if="result.result === 'engage'") 内定承諾
                            span(v-if="result.result === 'refuse'") 内定辞退

        b-row
          b-col.tags(v-if="currentUser.role !== 'agent'")
            h5.pl-2.mt-3.mb-2 タグ
            b-container.border.rounded.bg-white(fluid)
              b-row.my-2
                b-col.py-2(v-if="datum.tags && datum.tags.length > 0")
                  b-badge.tag.mr-1.mt-1(v-for="(tag, index) in datum.tags",:key="index",pill,variant="light")
                    span {{tag}}
              b-row.mb-2.pb-2(v-if="currentUser.role !== 'staff' && currentUser.role !== 'agent' && currentUser.role !== 'consultant'")
                b-col
                  b-button(size="sm",variant="secondary",@click="editTags()")
                    span(v-if="datum.tags && datum.tags.length > 0") タグの変更
                    span(v-else) タグの追加

        b-row.mt-3(v-if="currentUser.role !== 'agent'")
          b-col
            b-container.border.rounded.bg-white(fluid)
              b-row
                b-col.d-flex
                  h5.mt-3.mb-3.pl-0 選考ステータス
                    b-button(v-if="currentUser.role !== 'staff' && currentUser.role !== 'agent' && currentUser.role !== 'consultant'",:disabled="!datum.status || datum.status === '' || (datum.status === 'unevaluated' && datum.currentStep === 0) || datum.kept",size="sm",variant="link",@click="onPostRewind") 選考ステップを一つ戻す
              b-row
                b-col.steps
                  b-tabs(ref="tabs",v-if="datum.steps",:value="datum.currentStep ? datum.currentStep : 0")
                    b-tab(v-for="(step, index) in datum.steps",:key="index",:active="(datum.status === 'undecided' || datum.status === 'unevaluated' || datum.status === 'failure') && datum.currentStep === index",:title-item-class="datum.currentStep === index ? 'current' : datum.currentStep > index ? 'finished' : 'yet'")
                      template(slot="title")
                        span(:class="datum.currentStep === index ? 'current' : ''") {{ getStepTitle(step) }}
                      b-card.mb-3(no-body)
                        b-card-body.pt-1.pb-2.px-0
                          form.pl-3
                            .form-group.row(v-if="index > 0")
                              label.col-sm-3.readonly 開始日時:
                              .col-sm-9.form-control-plaintext.p-0 {{ datum.Schedules && datum.Schedules[index] && (datum.currentStep > index || (datum.currentStep == index && (datum.status === 'unevaluated' || datum.status === 'failure'))) ? formatDateTime(datum.Schedules[index].startAt) : '' }}
                                a.pl-3(v-if="datum.Schedules && datum.Schedules[index] && datum.Schedules[index].startAt && (datum.currentStep > index || (datum.currentStep == index && (datum.status === 'unevaluated' || datum.status === 'failure')))",:href="`https://www.google.com/calendar/render?action=TEMPLATE&dates=${ formatCalendarDateTime(datum.Schedules[index].startAt) }&text=${ encodeURIComponent(getStepTitle(step) + ' ' + datum.lastName + ' ' + datum.firstName + ' 様')}&location=${ datum.Schedules[index].location ? encodeURIComponent(datum.Schedules[index].location) : '' }&details=${ datum.Schedules[index].note ? encodeURIComponent(datum.Schedules[index].note) : '' }`",target="_blank")
                                  i.far.fa-calendar-plus
                                  span.pl-2 Googleカレンダーに登録

                            .form-group.row
                              label.col-sm-3.readonly 選考官:
                              .col-sm-9.form-control-plaintext.p-0 {{ datum.Schedules && datum.Schedules[index] && (datum.currentStep > index || (datum.currentStep == index && (datum.status === 'unevaluated' || datum.status === 'failure'))) ? getSelectorsName(datum.Schedules[index]) : '' }}

                            .form-group.row(v-if="index > 0")
                              label.col-sm-3.readonly 選考場所:
                              .col-sm-9.form-control-plaintext.p-0 {{ datum.Schedules && datum.Schedules[index] && (datum.currentStep > index || (datum.currentStep == index && (datum.status === 'unevaluated' || datum.status === 'failure'))) ? datum.Schedules[index].location : '' }}

                            .form-group.row
                              label.col-sm-3.readonly メッセージ:
                              pre.col-sm-9.form-control-plaintext.p-0 {{ datum.Schedules && datum.Schedules[index] && (datum.currentStep > index || (datum.currentStep == index && (datum.status === 'unevaluated' || datum.status === 'failure'))) ? datum.Schedules[index].note : '' }}

                            .form-group.row
                              label.col-sm-3.readonly 選考結果:
                              .col-sm-9.form-control-plaintext.p-0 {{ datum.Results && datum.Results[index] && (datum.currentStep > index || (datum.currentStep == index && datum.status === 'failure')) ? getResultTitle(datum.Results[index].result) : '' }}

                            .form-group.row
                              label.col-sm-3.readonly 選考コメント:
                              pre.col-sm-9.form-control-plaintext.p-0 {{ datum.Results && datum.Results[index] && (datum.currentStep > index || (datum.currentStep == index && datum.status === 'failure')) ? datum.Results[index].note : '' }}

                          b-card-footer.mt-3.p-0.bg-transparent.border-0(v-if="(!datum.status || datum.status === 'undecided' || datum.status === 'unevaluated') && Number(index) === Number(datum.currentStep)")
                            template(v-if="!datum.status || datum.status === ''")
                              template(v-if="currentUser.role !== 'staff'")
                                b-button(variant="primary",v-b-modal.modal-schedule) 書類選考設定

                            template(v-if="datum.status === 'unevaluated' && !datum.currentStep")
                              b-button(variant="primary",v-b-modal.modal-result,:disabled="!datum.isUpdatableResult || datum.kept") 書類選考結果を登録
                              template(v-if="currentUser.role !== 'staff'")
                                b-button.ml-2(variant="secondary",v-b-modal.modal-schedule,:disabled="datum.kept") 書類選考設定の変更

                            template(v-if="datum.status === 'unevaluated' && datum.currentStep")
                              b-button(variant="primary",@click="doRegistResult",:disabled="!datum.isUpdatableResult || datum.kept") {{ getStepTitle(datum.steps[datum.currentStep]) }}結果を登録
                              template(v-if="currentUser.role !== 'staff'")
                                b-button.ml-2(variant="secondary",v-b-modal.modal-schedule,:disabled="datum.kept") {{ getStepTitle(datum.steps[datum.currentStep]) }}設定の変更

                            template(v-if="datum.status === 'undecided'")
                              template(v-if="currentUser.role !== 'staff'")
                                b-button(variant="primary",v-b-modal.modal-schedule,:disabled="datum.kept") {{ getStepTitle(datum.steps[datum.currentStep]) }}設定

                    b-tab(:active="isOffer(datum)",:title-item-class="isOffer(datum) ? 'current' : isAgree(datum) ? 'finished' : 'yet'")
                      template(slot="title")
                        span 内定
                      b-card.mb-3(no-body)
                        b-card-body.py-3.px-2
                          form
                            .form-group.row
                              label.col-sm-3.readonly 内定日時:
                              .col-sm-9.form-control-plaintext.p-0 {{ datum.currentStep >= datum.steps.length && datum.Results && datum.Results[datum.steps.length - 1] && datum.Results[datum.steps.length - 1].postedAt ? formatDateTime(datum.Results[datum.steps.length - 1].postedAt) : '' }}

                            .form-group.row
                              label.col-sm-3.readonly 内定承諾結果:
                              .col-sm-9.form-control-plaintext.p-0 {{ (datum.currentStep > datum.steps.length || (datum.currentStep == datum.steps.length && datum.status === 'failure')) && datum.Results && datum.Results[datum.steps.length] ? datum.Results[datum.steps.length].result === 'engage' ? '承諾' : datum.Results[datum.steps.length].result === 'refuse' ? '辞退' : '' : '' }}

                            .form-group.row
                              label.col-sm-3.readonly コメント:
                              pre.col-sm-9.form-control-plaintext.p-0 {{ (datum.currentStep > datum.steps.length || (datum.currentStep == datum.steps.length && datum.status === 'failure')) && datum.Results && datum.Results[datum.steps.length] ? datum.Results[datum.steps.length].note : '' }}

                        b-card-footer.mt-3.p-0.bg-transparent.border-0(v-if="datum.status === 'offer' && !datum.employed")
                          template(v-if="currentUser.role !== 'staff' && currentUser.role !== 'consultant'")
                            b-button(variant="primary",v-b-modal.modal-agree) 内定承諾結果を登録
                          //-b-button.ml-2(variant="secondary",v-b-modal.modal-message) コメントを投稿

                    b-tab(:active="isAgree(datum)",:title-item-class="isAgree(datum) ? 'finished' : 'yet'")
                      template(slot="title")
                        span 入社決定
                      b-card.mb-3(no-body)
                        b-card-body.py-3.px-2
                          form
                            .form-group.row
                              label.col-sm-3.readonly 入社日:
                              .col-sm-9.form-control-plaintext.p-0 {{ datum.currentStep > datum.steps.length && datum.Results && datum.Results[datum.steps.length + 1] && datum.Results[datum.steps.length + 1].postedAt && datum.hireDate ? formatDay(datum.hireDate) : '' }}

                            .form-group.row
                              label.col-sm-3.readonly コメント:
                              pre.col-sm-9.form-control-plaintext.p-0 {{ datum.currentStep > datum.steps.length && datum.Results && datum.Results[datum.steps.length + 1] && datum.Results[datum.steps.length + 1].postedAt && datum.hireDate ? datum.Results[datum.steps.length + 1].note : '' }}

                        b-card-footer.mt-3.p-0.bg-transparent.border-0(v-if="datum.status === 'offer' && datum.employed")
                          template(v-if="currentUser.role !== 'staff' && currentUser.role !== 'consultant'")
                            b-button(v-if="!datum.hireDate",variant="primary",v-b-modal.modal-expect) 入社日の登録
                            b-button(v-if="datum.hireDate",variant="secondary",v-b-modal.modal-expect) 入社日の変更
                          //-b-button.ml-2(variant="secondary",v-b-modal.modal-message) コメントを投稿

        b-row.mt-3.mb-2
          b-col(cols=6)
            h5.pl-2.mt-3.mb-2 参考URL
            b-container.border.rounded.bg-white(fluid)
              b-row.my-3
                template(v-if="datum.links && datum.links.length > 0")
                  b-col.links.pl-3.pr-0
                    ul.mb-0
                      li.mr-3(v-for="(link, index) in datum.links",:key="index",:set="link")
                        a(:href="link.url",target="_blank")
                          .text-truncate(v-if="!link.caption") {{ link.url }}
                          .text-truncate(v-else) {{ link.caption }}
                template(v-else)
                  b-col
                    span.text-muted なし

            h5.pl-2.mt-3.mb-2 添付ファイル({{ datum.Files ? datum.Files.length : '0' }})
            b-container.border.rounded.bg-white(fluid)
              b-row.my-3
                template(v-if="datum.Files && datum.Files.length > 0")
                  b-col.files.py-2.pl-3.pr-0
                    span.file.mr-3.mb-2(v-for="(file, index) in datum.Files",:key="index")
                      b-button.p-0.text-left(variant="link",@click="selectPeopleFile(file, datum)")
                        span.text-wrap {{ file.filename }}
                template(v-else)
                  b-col
                    span.text-muted なし

            h5.pl-2.mt-3.mb-2 補足情報・メモ
            b-container.border.rounded.bg-white(fluid)
              b-row.my-3
                b-col
                  pre.note.m-0.p-0 {{ datum.note }}

            template
              h5.pl-2.mt-3.mb-2 学歴
              b-container.border.rounded.bg-white(fluid)
                b-row.my-2(v-if="datum.educations && datum.educations.length > 0")
                  b-col.px-2
                    table.table.educations
                      tbody
                        tr(v-for="(education, index) in datum.educations",:key="index")
                          td.border-0.text-nowrap {{ getYearMonth(education.enrolledAt) }} ~ {{ getYearMonth(education.graduatedAt) }}
                          td.border-0
                            .text-truncate {{ education.schoolName }}
                          td.border-0.text-nowrap {{ getAcademicQualificationTitle(education.qualification) }}
                b-row.my-3(v-else)
                  b-col
                    span.text-muted なし

            h5.pl-2.mt-3.mb-2 職歴
            b-container.border.rounded.bg-white(fluid)
              b-row.my-2(v-if="datum.careers && datum.careers.length > 0")
                b-col.px-2
                  table.table.careers
                    tbody
                      tr(v-for="(career, index) in datum.careers",:key="index")
                        td.border-0.text-nowrap {{ getYearMonth(career.joinedAt) }} ~ {{ getYearMonth(career.retiredAt) }}
                        td.border-0
                          .text-truncate {{ career.companyName }}
                        td.border-0.text-nowrap {{ getCareerTypeTitle(career.type) }}
              b-row.my-3(v-else)
                b-col
                  span.text-muted なし

          b-col.timeline(cols=6,v-if="currentUser.role !== 'agent'")
            h5.pl-2.mt-3.mb-2 タイムライン・コメント
            .position-absolute
              b-button.ml-2(size="sm",variant="secondary",@click="addMessage()") コメントを投稿

            b-container.border.rounded.bg-white(fluid)
              b-row.my-0
                b-col.px-0
                  table.table.messages.my-1
                    tbody
                      template(v-if="datum.Messages && datum.Messages.length > 0")
                        tr(v-for="(Log, index) in datum.Messages",:key="index")
                          td.border-0
                            p.caption
                              span.name {{ Log.PostedBy && Log.PostedBy.name ? Log.PostedBy.name : '-' }}
                              span.deleted {{ Log.PostedBy && Log.PostedBy.deleted ? '（削除済み）' : '' }}
                              span.date {{ Log.postedAt ? `${formatDateTime(Log.postedAt)}` : '-' }}
                            b-button.edit.mr-2(v-if="Log.class && Log.class === 'messagePost' && (currentUser.role === 'admin' || currentUser.role === 'master' || String(Log.PostedBy._id) === String(currentUser._id))",variant="link",@click="editMessage(Log)")
                              i.fas.fa-edit
                            b-button.remove(v-if="currentUser.role === 'admin' || currentUser.role === 'master' || String(Log.PostedBy._id) === String(currentUser._id)",variant="link",@click="removeMessage(index)")
                              i.fas.fa-times
                            pre.message.p-0 {{ Log.message }}
                        tr.infinite
                          td
                            infinite-loading(ref="messageInfinite",@infinite="onMessageInfinite",v-if="messageList.next")

                      template(v-else)
                        tr
                          td.border-0
                            .text-muted なし

  b-modal#modal-schedule(hide-header,@show="initModal('schedule')")
    b-form.text-left(ref="formSchedule",@submit.prevent)
      ValidationObserver(slim,ref="observerSchedule")
        template(v-if="datum.currentStep")
          b-form-group(label="",label-for="input-startDate",description="",required)
            label.d-block 開始日時:
            .form-inline.d-flex.align-items-start
              ValidationProvider(rules="required|date",name="開始日",v-slot="{ errors }")
                b-input-group
                  b-form-input#input-startDate(v-model="startDate",type="date",placeholder="年/月/日",pattern="((19|20)\d\d)[\/\-]([1-9]|0[1-9]|1[012])[\/\-]([1-9]|0[1-9]|[12][0-9]|3[01])",required,@input="validateScheduleInput")
                  //-b-input-group-append
                    //b-form-datepicker(v-model="startDate",locale="ja-JP",:date-format-options="{ year:'numeric', month: '2-digit', day: '2-digit', weekday: 'narrow' }",placeholder="開始日を設定",@input="validateScheduleInput")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              ValidationProvider(rules="required|time",name="開始時刻",v-slot="{ errors }")
                b-input-group
                  b-form-input#input-startTime.ml-3(v-model="startTime",type="time",placeholder="時:分",@input="validateScheduleInput")
                  //-b-input-group-append
                    //b-form-timepicker(v-model="startTime",button-only,show-seconds=false,locale="ja-JP",no-close-button,placeholder="開始時刻を設定",@input="validateScheduleInput")
                  .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
        template(v-if="(!datum.status || datum.status === '') || datum.status !== 'employ'")
          b-form-group(label="選考官",label-for="input-selectors",description="",required)
            ValidationProvider(rules="required",name="選考官",v-slot="{ errors }")
              v-select#input-selectors(ref="selectors",v-model="selectors",multiple,:filterable="false",:options="option.selectors",label="name",@input="validateScheduleInput",@search="onSelectorSearch",placeholder="選考官を指定してください")
                template(slot="no-options")
                  span type name to search Users...
                template(slot="option",slot-scope="option")
                  .d-center
                    span {{ `${option.name}` }}
                template(slot="selected-option",slot-scope="option")
                  .d-center.selected
                    span {{ `${option.name}` }}
              .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
        template(v-if="datum.currentStep")
          b-form-group(label="選考場所",label-for="input-location",description="")
            ValidationProvider(rules="",name="選考場所",v-slot="{ errors }")
              b-form-input#input-location(v-model="location",type="text",max-rows="20",@input="validateScheduleInput",placeholder="選考場所を入力してください")
              .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
        b-form-group.mb-0(label="選考官へのメッセージ",label-for="input-message",description="")
          .position-absolute.boilerplates(v-if="option.boilerplates && option.boilerplates['30']")
            b-form-select(size="sm",v-model="boilerplate",:options="option.boilerplates['30']",@change="selectBoilerplates($event, 'note')")
          ValidationProvider(rules="max:1000",name="選考官へのメッセージ",v-slot="{ errors }")
            b-form-textarea#input-message(v-model="note",max-rows="20",@input="validateScheduleInput",placeholder="メッセージを入力してください")
            .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
    template(v-slot:modal-footer="{ ok, cancel }")
      b-button(variant="secondary",@click="$bvModal.hide('modal-schedule')") キャンセル
      b-button(variant="primary",@click="onPostSchedule()",:disabled="!validSchedule") 設定する

  b-modal#modal-result(hide-header,@show="initModal('result')")
    b-form.text-left(ref="formResult",@submit.prevent)
      ValidationObserver(slim,ref="observerResult")
        b-form-group(label="選考結果",label-for="input-judge",description="",required)
          ValidationProvider(rules="required",name="選考結果",v-slot="{ errors }")
            b-form-radio-group#input-judge(buttons,button-variant="outline-secondary",v-model="result",type="text",max-rows="20",@input="validateResultInput",placeholder="")
              b-form-radio(button-variant="outline-primary",value="pass") 合格
              b-form-radio(button-variant="outline-danger",value="fail") 不合格
              b-form-radio(button-variant="outline-danger",value="decline") 辞退
              b-form-radio(button-variant="outline-danger",value="terminate") 選考終了
            .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
        b-form-group.mb-0(label="選考コメント",label-for="input-message",description="")
          .position-absolute.boilerplates(v-if="option.boilerplates && option.boilerplates[40]")
            b-form-select(size="sm",v-model="boilerplate",:options="option.boilerplates[40]",@change="selectBoilerplates($event, 'note')")
          ValidationProvider(rules="max:1000",name="選考コメント",v-slot="{ errors }")
            b-form-textarea#input-note(v-model="note",max-rows="20",@input="validateResultInput",placeholder="コメントを入力してください")
            .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
    template(v-slot:modal-footer="{ ok, cancel }")
      b-button(variant="secondary",@click="$bvModal.hide('modal-result')") キャンセル
      b-button(variant="primary",@click="onPostResult()",:disabled="!validResult") 登録する

  b-modal#modal-agree(hide-header,@show="initModal('agree')")
    b-form.text-left(ref="formAgree",@submit.prevent)
      ValidationObserver(slim,ref="observerAgree")
        b-form-group(label="内定承諾",label-for="input-agree",description="",required)
          ValidationProvider(rules="required",name="内定承諾",v-slot="{ errors }")
            b-form-radio-group#input-agree(buttons,button-variant="outline-secondary",v-model="agree",type="text",max-rows="20",@input="validateAgreeInput",placeholder="")
              b-form-radio(button-variant="outline-primary",value="engage") 承諾
              b-form-radio(button-variant="outline-danger",value="refuse") 辞退
            .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
        b-form-group.mb-0(label="コメント",label-for="input-note",description="")
          .position-absolute.boilerplates(v-if="option.boilerplates && option.boilerplates[70]")
            b-form-select(size="sm",v-model="boilerplate",:options="option.boilerplates[70]",@change="selectBoilerplates($event, 'note')")
          ValidationProvider(rules="max:1000",name="コメント",v-slot="{ errors }")
            b-form-textarea#input-note(v-model="note",max-rows="20",@input="validateAgreeInput",placeholder="コメントを入力してください")
            .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
    template(v-slot:modal-footer="{ ok, cancel }")
      b-button(variant="secondary",@click="$bvModal.hide('modal-agree')") キャンセル
      b-button(variant="primary",@click="onPostAgree()",:disabled="!validAgree") 登録する

  b-modal#modal-expect(hide-header,@show="initModal('expect')")
    b-form.text-left(ref="formExpect",@submit.prevent)
      ValidationObserver(slim,ref="observerExpect")
        template(v-if="datum.status && datum.status !== ''")
          b-form-group(label="入社日",label-for="input-hireDate",description="",required)
            .form-inline.d-flex.align-items-start
              ValidationProvider(rules="required|date",name="入社日",v-slot="{ errors }")
                b-input-group
                  b-form-input#input-hireDate(v-model="hireDate",type="date",placeholder="年/月/日",pattern="((19|20)\d\d)[\/\-]([1-9]|0[1-9]|1[012])[\/\-]([1-9]|0[1-9]|[12][0-9]|3[01])",required,@input="validateExpectInput")
                  //-b-input-group-append
                    //b-form-datepicker(v-model="hireDate",locale="ja-JP",:date-format-options="{ year:'numeric', month: '2-digit', day: '2-digit', weekday: 'narrow' }",placeholder="入社日を設定してください",@input="validateExpectInput")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
          b-form-group.mb-0(label="コメント",label-for="input-note",description="")
            .position-absolute.boilerplates(v-if="option.boilerplates && option.boilerplates[80]")
              b-form-select(size="sm",v-model="boilerplate",:options="option.boilerplates[80]",@change="selectBoilerplates($event, 'note')")
            ValidationProvider(rules="max:1000",name="コメント",v-slot="{ errors }")
              b-form-textarea#input-note(v-model="note",max-rows="20",@input="validateExpectInput",placeholder="コメントを入力してください")
              .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
    template(v-slot:modal-footer="{ ok, cancel }")
      b-button(variant="secondary",@click="$bvModal.hide('modal-expect')") キャンセル
      b-button(variant="primary",@click="onPostExpect()",:disabled="!validExpect") 登録する

  b-modal#modal-tags(hide-header,no-close-on-backdrop,@show="initModal('tags')")
    template(v-slot:default)
      b-form.text-left(ref="formTags",@submit.prevent)
        ValidationObserver(slim,ref="observerTags")
          b-form-group.mb-0(label="タグ",label-for="input-tags")
            ValidationProvider(rules="",name="タグ",v-slot="{ errors }")
              v-select#input-tags(ref="tags",v-model="selected.tags",taggable,multiple,:filterable="false",:options="option.tags",label="text",placeholder="検索用のタグを入力してください",@input="validateTagsInput",@search="onTagSearch")
                template(slot="no-options")
                  span type name to search tags...
                template(slot="option",slot-scope="option")
                  span {{ option.text }}
                template(slot="selected-option",slot-scope="option")
                  span {{ option.text }}
              .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
    template(v-slot:modal-footer="{ ok, cancel }")
      b-button(variant="secondary",@click="$bvModal.hide('modal-tags')") キャンセル
      b-button(variant="primary",@click="onPatchTags()",:disabled="!validTags || !changedTags")
        span 保存

  b-modal#modal-message(hide-header,@show="initModal('message')")
    template(v-slot:default)
      b-form.text-left(ref="formMessage",@submit.prevent)
        ValidationObserver(slim,ref="observerMessage")
        b-form-group.mb-0(label="コメント",label-for="input-note",description="",required)
          .position-absolute.boilerplates(v-if="option.boilerplates && option.boilerplates[10]")
            b-form-select(size="sm",v-model="boilerplate",:options="option.boilerplates[10]",@change="selectBoilerplates($event, 'message')")
          ValidationProvider(rules="required|max:1000",name="コメント",v-slot="{ errors }")
            b-form-textarea#input-note(v-model="message",max-rows="20",@input="validateMessageInput",placeholder="コメントを入力してください")
            .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
    template(v-slot:modal-footer="{ ok, cancel }")
      b-button(variant="secondary",@click="$bvModal.hide('modal-message')") キャンセル
      template(v-if="formerMessage")
        b-button(variant="primary",@click="onPatchMessage()",:disabled="!validMessage")
          span 変更する
      template(v-else)
        b-button(variant="primary",@click="onPostMessage()",:disabled="!validMessage")
          span 投稿する

  b-modal#modal-preview(hide-header,size="xl",@shown="shownPeopleFile",@hidden="hiddenPeopleFile")
    template(v-slot:default)
      .previewWrapper(v-if="previewFile")
        template(v-if="previewFile && (previewFile.extension === 'png' || previewFile.extension === 'jpeg' || previewFile.extension === 'gif' || previewFile.extension === 'bmp' || previewFile.extension === 'svg')")
          img.img-fluid.mx-auto#previewPeopleFile
        template(v-if="previewFile && previewFile.extension === 'pdf'")
          #previewPeopleFile.pdf
        template(v-if="previewFile && previewFile.extension === 'markdown'")
          #previewPeopleFile.markdown
    template(v-slot:modal-footer="{ ok, cancel }")
      b-button(variant="primary",@click="downloadPeopleFile") ダウンロード
      b-button(variant="secondary",@click="$bvModal.hide('modal-preview')") 閉じる
</template>

<script>
import QueryHash from 'query-hash'

import { getData, postData, patchData, deleteData } from '../utils/api'

import { clone, difference, getGender, getAge, getYearMonth, getAcademicQualificationTitle, getCareerTypeTitle, getStepTitle, getResultTitle } from '../utils/libs'

import 'dayjs/locale/ja'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.locale('ja')
dayjs.extend(localizedFormat)

const page = {
  id: 'status',
  title: '候補者状況'
}

export default {
  // props: ['mode'],
  data () {
    return {
      mask: false,
      lock: false,
      page: page,
      collapsed: true,
      currentUser: null,
      datum: {},
      validSchedule: null,
      startDate: null,
      startTime: null,
      selected: {
        tags: {}
      },
      option: {
        tags: [],
        selectors: []
      },
      selectors: [],
      boilerplate: null,
      location: '',
      note: '',
      validResult: null,
      result: null,
      validAgree: null,
      agree: '',
      validExpect: null,
      hireDate: null,
      validTags: null,
      changedTags: null,
      validMessage: null,
      message: null,
      messageList: {
        limit: 10,
        current: 0,
        total: 0,
        next: false
      },
      formerMessage: null,
      previewFile: null
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    formatDay (val) {
      if (!val) {
        val = new Date()
      }
      return val ? dayjs(val).format('YYYY/MM/DD(ddd)') : '-'
    },
    formatDateTime (val) {
      return val ? dayjs(val).format('YYYY/MM/DD(ddd) HH:mm') : '-'
    },
    formatCalendarDateTime (val) {
      return val ? dayjs(val).format('YYYYMMDDTHHmmss') + '/' + dayjs(val).add(1, 'hours').format('YYYYMMDDTHHmmss') : ''
    },
    editTags () {
      this.$bvModal.show('modal-tags')
    },
    selectPeopleFile (file, people) {
      if (file.extension === 'png' || file.extension === 'jpeg' || file.extension === 'gif' || file.extension === 'bmp' || file.extension === 'svg' || file.extension === 'pdf' || file.extension === 'markdown') {
        this.previewPerson = people
        this.previewFile = file
        this.$bvModal.show('modal-preview')
      } else {
        this.download(`/peoples/${people._id}/files/${file._id}.${file.extension}`, `${file.filename}`)
      }
    },
    shownPeopleFile () {
      this.preview(`/peoples/${this.previewPerson._id}/files/${this.previewFile._id}.${this.previewFile.extension}`, `${this.previewFile.filename}`, 'previewPeopleFile')
    },
    hiddenPeopleFile () {
      this.previewPerson = null
      this.previewFile = null
    },
    downloadPeopleFile () {
      this.download(`/peoples/${this.previewPerson._id}/files/${this.previewFile._id}.${this.previewFile.extension}`, `${this.previewFile.filename}`)
    },
    isOffer (datum) {
      return (datum.status === 'offer' && datum.employed === null) || (datum.status === 'failure' && datum.currentStep === datum.steps.length)
    },
    isAgree (datum) {
      return datum.status === 'offer' && datum.employed
    },
    getGender (val) {
      return getGender(val)
    },
    getAge (val) {
      return getAge(val)
    },
    getYearMonth (val) {
      return getYearMonth(val)
    },
    getAcademicQualificationTitle (val) {
      return getAcademicQualificationTitle(val)
    },
    getCareerTypeTitle (val) {
      return getCareerTypeTitle(val)
    },
    getStepTitle (val) {
      return getStepTitle(val)
    },
    getResultTitle (val) {
      return getResultTitle(val)
    },
    getSelectorsName (schedule) {
      let selectors = []

      if (schedule.Selectors) {
        schedule.Selectors.forEach((selector) => {
          const findSelector = selectors.find((checkSelector) => {
            return selector._id === checkSelector._id
          })
          if (!findSelector) {
            selectors.push(selector)
          }
        })
      }

      let selectorNames = []

      selectors.forEach((selector) => {
        let selectorName = selector.name
        if (selector.deleted) {
          selectorName += '（削除済み）'
        }
        selectorNames.push(selectorName)
      })

      return selectorNames.join(', ')
    },
    expandMessage (index) {
      if (this.datum.Messages[index].expand) {
        this.datum.Messages[index].expand = false
      } else {
        this.datum.Messages[index].expand = true
      }
      this.$forceUpdate()
    },
    addMessage () {
      this.formerMessage = null
      this.$bvModal.show('modal-message')
    },
    editMessage (row) {
      this.formerMessage = clone(row)
      this.$bvModal.show('modal-message')
    },
    async removeMessage (index) {
      this.msgBoxConfirm('タイムライン・コメントを削除しますか？', async () => {
        await deleteData(`/peoples/${this.$route.params.id}/messages/${this.datum.Messages[index]._id}`).then((json) => {
          this.datum.Messages = []

          this.messageList.current = 0
          this.messageList.total = 0
          this.messageList.next = true

          this.loadMessageData()
        })
      })
    },
    selectBoilerplates (text, variant) {
      if (text) {
        this.$data[variant] = text
        this.boilerplate = null
      }
    },
    async loadData () {
      if (!this.$root.currentUser || !this.$root.currentUser.role) {
        setTimeout(() => {
          this.loadData()
        }, 300)
        return
      }
      this.$set(this, 'currentUser', this.$root.currentUser)

      if (this.$route.params.id) {
        this.mask = true

        let message = null

        this.option.boilerplates = {}
        await getData(`/boilerplates`).then((boilerplates) => {
          boilerplates.forEach((boilerplate) => {
            if (!this.option.boilerplates[boilerplate.type]) {
              this.option.boilerplates[boilerplate.type] = [{
                value: null,
                text: 'メッセージテンプレート',
                disabled: true
              }]
            }
            this.option.boilerplates[boilerplate.type].push({
              value: boilerplate.text,
              text: boilerplate.caption
            })
          })
        }).catch((err) => {
          console.log(err)
        })

        this.datum = {}
        this.datum.currentStep = null // clear active tab

        this.selected.tags = []

        await getData(`/peoples/${this.$route.params.id}`).then(async (datum) => {
          if (datum) {
            this.datum = clone(datum)

            /*
            if (!datum.Saw) {
              postData(`/peoples/${this.$route.query.id}/saw`)
            }
            */

            if (this.datum.tags && Array.isArray(this.datum.tags) && this.datum.tags.length > 0) {
              this.selected.tags = clone(this.datum.tags)
            }

            if (!datum.currentStep) {
              this.datum.currentStep = 0
            }

            this.messageList.current = 0
            this.messageList.total = 0

            if (datum.Messages && datum.Messages.length > 0) {
              await getData(`/peoples/${this.$route.params.id}/messages/count`).then((count) => {
                if (count > 0) {
                  this.messageList.current = 1
                  this.messageList.total = count
                  this.messageList.next = true
                }
              })
            }

            this.datum.isUpdatableResult = false
            if (this.currentUser.role === 'admin' || this.currentUser.role === 'master') {
              this.datum.isUpdatableResult = true
            } else {
              if (this.datum.jobId) {
                let postableUserIds = []

                let jobDatum = {}
                await getData(`/jobs/${this.datum.jobId}`).then((datum) => {
                  jobDatum = datum
                })

                if (jobDatum.Managers && Array.isArray(jobDatum.Managers) && jobDatum.Managers.length > 0) {
                  jobDatum.Managers.forEach((manager) => {
                    const existUser = postableUserIds.find((userId) => {
                      return String(userId) === String(manager._id)
                    })
                    if (!existUser) {
                      postableUserIds.push(manager._id)
                    }
                  })
                }
                if (jobDatum.Recruiters && Array.isArray(jobDatum.Recruiters) && jobDatum.Recruiters.length > 0) {
                  jobDatum.Recruiters.forEach((recruiter) => {
                    const existUser = postableUserIds.find((userId) => {
                      return String(userId) === String(recruiter._id)
                    })
                    if (!existUser) {
                      postableUserIds.push(recruiter._id)
                    }
                  })
                }
                if (jobDatum.Staffs && Array.isArray(jobDatum.Staffs) && jobDatum.Staffs.length > 0) {
                  jobDatum.Staffs.forEach((staff) => {
                    const existUser = postableUserIds.find((userId) => {
                      return String(userId) === String(staff._id)
                    })
                    if (!existUser) {
                      postableUserIds.push(staff._id)
                    }
                  })
                }

                const postableUser = postableUserIds.find((userId) => {
                  return String(userId) === String(this.$root.currentUser._id)
                })

                if (postableUser) {
                  this.datum.isUpdatableResult = true
                } else {
                  let postableSelector = null

                  let currentSchedule = null
                  if (this.datum.Schedules && Array.isArray(this.datum.Schedules) && this.datum.Schedules.length > 0) {
                    currentSchedule = this.datum.Schedules.find((schedule) => {
                      return schedule.step === this.datum.currentStep
                    })
                  }
                  if (currentSchedule && Array.isArray(currentSchedule.Selectors) && currentSchedule.Selectors.length > 0) {
                    postableSelector = currentSchedule.Selectors.find((selector) => {
                      return String(selector._id) === String(this.$root.currentUser._id)
                    })
                  }

                  if (postableSelector) {
                    this.datum.isUpdatableResult = true
                  }
                }
              }
            }
          } else {
            message = '候補者が未登録か削除済または閲覧権限がないため表示できません'
          }
        }).catch((err) => {
          console.log(err)

          message = 'データの読込に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })

        if (this.$refs.status) {
          this.$refs.status.scrollTop = 0
        }

        if (this.$refs.tabs) {
          // this.$refs.tabs.refresh()
        }

        this.mask = false

        if (message) {
          this.msgBoxError(message)
        } else {
          this.$forceUpdate()
        }
      }
    },
    onEdit () {
      // this.handleLink(`/${this.$route.params.directory}/people/edit/${this.datum._id}`)
      this.handleLink(`/${this.$route.params.directory}/people/edit/${this.datum._id}`)
    },
    onClose () {
      this.doClose()
    },
    doClose () {
      this.handleLink(`/${this.$route.params.directory}/peoples`)
    },
    doRegistResult () {
      if (dayjs(this.datum.nextScreeningDate) > dayjs()) {
        this.msgBoxConfirm('開始日前です。結果を登録しますか？', () => {
          this.$bvModal.show('modal-result')
        })
      } else {
        this.$bvModal.show('modal-result')
      }
    },
    async initModal (title) {
      this.boilerplate = null

      if (title === 'schedule') {
        this.validSchedule = false

        if (this.datum.status === 'unevaluated') {
          let currentSchedule = null
          if (this.datum.Schedules && Array.isArray(this.datum.Schedules) && this.datum.Schedules.length > 0) {
            currentSchedule = this.datum.Schedules.find((schedule) => {
              return schedule.step === this.datum.currentStep
            })
          }
          if (currentSchedule) {
            if (currentSchedule.startAt) {
              this.startDate = dayjs(currentSchedule.startAt).format('YYYY-MM-DD')
              this.startTime = dayjs(currentSchedule.startAt).format('HH:mm')
            }
            if (currentSchedule.Selectors) {
              this.selectors = clone(currentSchedule.Selectors)
              // this.option.selectors = this.selectors
            }
            this.location = ''
            if (currentSchedule.location) {
              this.location = currentSchedule.location
            }
            this.note = ''
            if (currentSchedule.note) {
              this.note = currentSchedule.note
            }
          }

          let query = new QueryHash()

          let filters = []

          filters.push({ role: { $nin: ['admin'] } })

          if (this.selectors.length > 0) {
            let selectedIds = []
            if (this.selectors && this.selectors.length > 0) {
              this.selectors.forEach((selector) => {
                selectedIds.push(`ObjectId:('${selector._id}')`)
              })
              if (selectedIds.length > 0) {
                filters.push({ _id: { $nin: selectedIds } })
              }
            }
          }

          query.add('filter', JSON.stringify({ $and: filters }))

          query.add('jobId', this.datum.jobId)
          query.add('fields', '_id,name')

          this.option.selectors = []
          await getData(`/users?${query.toQueryString()}`).then((data) => {
            this.option.selectors = data
          })
        } else {
          this.startDate = null
          this.startTime = null
          this.selectors = []
          this.location = ''
          this.note = ''

          let query = new QueryHash()

          query.add('filter', JSON.stringify({ role: { $nin: ['admin'] } }))

          query.add('jobId', this.datum.jobId)
          query.add('fields', '_id,name')

          await getData(`/users?${query.toQueryString()}`).then((data) => {
            this.option.selectors = data
          })
        }
      } else if (title === 'result') {
        this.result = []
        this.note = ''
        this.validResult = false
      } else if (title === 'agree') {
        this.agree = ''
        this.note = ''
        this.validAgree = false
      } else if (title === 'expect') {
        this.hireDate = null
        if (this.datum.hireDate) {
          this.hireDate = this.datum.hireDate
        }
        this.note = ''
        this.validExpect = false
      } else if (title === 'tags') {
        this.validTags = false
        this.changedTags = false
      } else if (title === 'message') {
        this.validMessage = false
        this.message = ''
        if (this.formerMessage && this.formerMessage.message) {
          this.message = this.formerMessage.message
        }
      }
    },
    async onSelectorSearch (search, loading) {
      // if (!search) { return }
      const that = this
      loading(true)

      let query = new QueryHash()
      let filters = []

      filters.push({ role: { $nin: ['admin'] } })

      if (search) {
        filters.push({
          $or: [
            { name: `RegExp:('${search}')` },
            { email: `RegExp:('${search}')` }
          ]
        })
      }

      let selectedIds = []
      if (this.selectors && this.selectors.length > 0) {
        this.selectors.forEach((selector) => {
          selectedIds.push(`ObjectId:('${selector._id}')`)
        })
        if (selectedIds.length > 0) {
          filters.push({ _id: { $nin: selectedIds } })
        }
      }

      query.add('filter', JSON.stringify({ $and: filters }))

      query.add('jobId', this.datum.jobId)
      query.add('fields', '_id,name')

      await getData(`/users?${query.toQueryString()}`).then((data) => {
        that.$data.option.selectors = data
        loading(false)
      })
    },
    validateScheduleInput () {
      this.validSchedule = this.$refs.formSchedule.checkValidity()

      if (this.datum.currentStep && (!this.startDate || !this.startTime)) {
        this.validSchedule = false
      }

      if (!this.selectors || this.selectors.length === 0) {
        this.validSchedule = false
      }

      if (this.validSchedule) {
        this.$nextTick(async () => {
          this.validSchedule = await this.$refs.observerSchedule.validate()
        })
      }
    },
    validateResultInput () {
      this.validResult = this.$refs.formResult.checkValidity()
      if (this.validResult) {
        this.$nextTick(async () => {
          this.validResult = await this.$refs.observerResult.validate()
        })
      }
    },
    validateAgreeInput () {
      this.validAgree = this.$refs.formAgree.checkValidity()
      if (this.validAgree) {
        this.$nextTick(async () => {
          this.validAgree = await this.$refs.observerAgree.validate()
        })
      }
    },
    validateExpectInput () {
      this.validExpect = this.$refs.formExpect.checkValidity()
      if (this.validExpect) {
        this.$nextTick(async () => {
          this.validExpect = await this.$refs.observerExpect.validate()
        })
      }
    },
    async onTagSearch (search, loading) {
      const that = this
      loading(true)

      let query = new QueryHash()

      query.add('filter', JSON.stringify({ text: `RegExp:('${search}')` }))
      query.add('fields', '_id,text,count')
      query.add('sort', 'count')
      query.add('limit', -1)

      await getData(`/tags?${query.toQueryString()}`).then((data) => {
        that.option.tags = data
      })
      loading(false)
    },
    validateTagsInput () {
      this.validTags = this.$refs.formTags.checkValidity()
      if (this.validTags) {
        this.$nextTick(async () => {
          this.validTags = await this.$refs.observerTags.validate()
        })
      }
      this.changedTags = difference(this.datum.tags, this.selected.tags)
    },
    validateMessageInput () {
      this.validMessage = this.$refs.formMessage.checkValidity()
      if (!this.message || this.message.length === 0 || this.message.trim() === '') {
        this.validMessage = false
      }
      if (this.validMessage) {
        this.$nextTick(async () => {
          this.validMessage = await this.$refs.observerMessage.validate()
        })
      }
    },
    async onPostSchedule () {
      this.msgBoxConfirm('選考情報を設定しますか？', this.doPostSchedule)
    },
    async doPostSchedule () {
      let scheduleDatum = {}

      if (!this.datum.status || this.datum.status === '') {
        scheduleDatum.step = 0
      } else {
        scheduleDatum.step = this.datum.currentStep
      }

      scheduleDatum.selectors = []
      this.selectors.forEach((selector) => {
        scheduleDatum.selectors.push(selector._id)
      })
      if (this.datum.status && this.datum.status !== '' && this.startDate && this.startTime) {
        scheduleDatum.startAt = dayjs(`${this.startDate} ${this.startTime}`).format('YYYY-MM-DD HH:mm')
      }
      if (this.location && this.location !== '') {
        scheduleDatum.location = this.location
      }
      if (this.note && this.note !== '') {
        scheduleDatum.note = this.note
      }

      await postData(`/peoples/${this.datum._id}/schedules`, scheduleDatum).then(async (json) => {
        this.$bvModal.hide('modal-schedule')

        this.loadData()
      }).catch((err) => {
        console.log(err)

        let message = 'データの保存に失敗しました'

        if (err.response.data) {
          if (err.response.data.code && err.response.data.message) {
            message = err.response.data.message
          } else if (err.response.data.message) {
            message = err.response.data.message
          }
        }

        this.msgBoxError(message)
      })
    },
    async onPostResult () {
      this.msgBoxConfirm('選考結果を登録しますか？', this.doPostResult)
    },
    async doPostResult () {
      const resultDatum = {
        step: this.datum.currentStep,
        result: this.result,
        note: this.note
      }

      await postData(`/peoples/${this.datum._id}/results`, resultDatum).then(async (json) => {
        this.$bvModal.hide('modal-result')

        this.loadData()
      }).catch((err) => {
        console.log(err)

        let message = 'データの保存に失敗しました'

        if (err.response.data) {
          if (err.response.data.code && err.response.data.message) {
            message = err.response.data.message
          } else if (err.response.data.message) {
            message = err.response.data.message
          }
        }

        this.msgBoxError(message)
      })
    },
    async onPostAgree () {
      this.msgBoxConfirm('承諾結果を登録しますか？', this.doPostAgree)
    },
    async doPostAgree () {
      const resultDatum = {
        step: this.datum.currentStep,
        result: this.agree,
        note: this.note
      }

      await postData(`/peoples/${this.datum._id}/results`, resultDatum).then(async (json) => {
        this.$bvModal.hide('modal-agree')

        this.loadData()
      }).catch((err) => {
        console.log(err)

        let message = 'データの保存に失敗しました'

        if (err.response.data) {
          if (err.response.data.code && err.response.data.message) {
            message = err.response.data.message
          } else if (err.response.data.message) {
            message = err.response.data.message
          }
        }

        this.msgBoxError(message)
      })
    },
    async onPostExpect () {
      this.msgBoxConfirm('入社日を登録しますか', this.doPostExpect)
    },
    async doPostExpect () {
      const expectDatum = {
        hireDate: dayjs(this.hireDate).format('YYYY-MM-DD'),
        note: this.note
      }

      await postData(`/peoples/${this.datum._id}/expect`, expectDatum).then(async (json) => {
        this.$bvModal.hide('modal-expect')

        this.loadData()
      }).catch((err) => {
        console.log(err)

        let message = 'データの保存に失敗しました'

        if (err.response.data) {
          if (err.response.data.code && err.response.data.message) {
            message = err.response.data.message
          } else if (err.response.data.message) {
            message = err.response.data.message
          }
        }

        this.msgBoxError(message)
      })
    },
    async onPostRewind () {
      this.msgBoxConfirm('選考ステップを一つ戻しますか？', this.doPostRewind)
    },
    async doPostRewind () {
      const rewindDatum = {
        currentStatus: this.datum.status,
        currentStep: this.datum.currentStep
      }

      await postData(`/peoples/${this.datum._id}/rewind`, rewindDatum).then(async (json) => {
        this.loadData()
      }).catch((err) => {
        console.log(err)

        let message = 'データの保存に失敗しました'

        if (err.response.data) {
          if (err.response.data.code && err.response.data.message) {
            message = err.response.data.message
          } else if (err.response.data.message) {
            message = err.response.data.message
          }
        }

        this.msgBoxError(message)
      })
    },
    async onPatchTags () {
      let tags = []

       if (this.selected.tags && this.selected.tags.length > 0) {
         this.selected.tags.forEach((tag) => {
           if (tag && tag.text) {
             tags.push(tag.text)
           } else {
             tags.push(String(tag))
           }
         })
       }

      await patchData(`/peoples/${this.datum._id}/tags`, { tags: tags }).then(async (json) => {
        this.$bvModal.hide('modal-tags')

        this.loadData()
      }).catch((err) => {
        console.log(err)

        let message = 'データの保存に失敗しました'

        if (err.response.data) {
          if (err.response.data.code && err.response.data.message) {
            message = err.response.data.message
          } else if (err.response.data.message) {
            message = err.response.data.message
          }
        }

        this.msgBoxError(message)
      })

    },
    async onPostMessage () {
      const messageDatum = {
        message: this.message
      }

      await postData(`/peoples/${this.datum._id}/messages`, messageDatum).then(async (json) => {
        this.$bvModal.hide('modal-message')

        this.loadData()
      }).catch((err) => {
        console.log(err)

        let message = 'データの保存に失敗しました'

        if (err.response.data) {
          if (err.response.data.code && err.response.data.message) {
            message = err.response.data.message
          } else if (err.response.data.message) {
            message = err.response.data.message
          }
        }

        this.msgBoxError(message)
      })
    },
    async onPatchMessage () {
      const messageDatum = {
        message: this.message
      }

      await patchData(`/peoples/${this.datum._id}/messages/${this.formerMessage._id}`, messageDatum).then(async (json) => {
        this.$bvModal.hide('modal-message')

        this.loadData()
      }).catch((err) => {
        console.log(err)

        let message = 'データの保存に失敗しました'

        if (err.response.data) {
          if (err.response.data.code && err.response.data.message) {
            message = err.response.data.message
          } else if (err.response.data.message) {
            message = err.response.data.message
          }
        }

        this.msgBoxError(message)
      })
    },
    async loadMessageData () {
      this.mask = true

      let query = new QueryHash()

      query.add('sort', '-postedAt')
      query.add('limit', this.messageList.limit)
      query.add('skip', this.messageList.current * this.messageList.limit)

      await getData(`/peoples/${this.datum._id}/messages?${query.toQueryString()}`).then((data) => {
        if (data && data.length > 0) {
          this.datum.Messages.push(...data)

          this.messageList.total += data.length
          this.messageList.current++

          if (data.length < this.messageList.limit) {
            this.messageList.next = false
          }
        } else {
          this.messageList.next = false
        }
      }).catch((err) => {
        console.log(err)
      })

      this.mask = false
    },
    async onMessageInfinite (elm) {
      await this.loadMessageData()

      if (this.messageList.next) {
        elm.loaded()
      } else {
        elm.complete()
      }
    },
    async onKeep () {
      this.msgBoxConfirm('候補者の選考を保留にしますか？', this.doKeep)
    },
    async doKeep () {
      await patchData(`/peoples/${this.datum._id}/keep`).then(async (json) => {
        this.loadData()
      }).catch((err) => {
        console.log(err)

        let message = 'データの保存に失敗しました'

        if (err.response.data) {
          if (err.response.data.code && err.response.data.message) {
            message = err.response.data.message
          } else if (err.response.data.message) {
            message = err.response.data.message
          }
        }

        this.msgBoxError(message)
      })
    },
    async onKeepOff () {
      this.msgBoxConfirm('候補者の選考が保留されています。保留を解除しますか？', this.doKeepOff)
    },
    async doKeepOff () {
      await patchData(`/peoples/${this.datum._id}/keepoff`).then(async (json) => {
        this.loadData()
      }).catch((err) => {
        console.log(err)

        let message = 'データの保存に失敗しました'

        if (err.response.data) {
          if (err.response.data.code && err.response.data.message) {
            message = err.response.data.message
          } else if (err.response.data.message) {
            message = err.response.data.message
          }
        }

        this.msgBoxError(message)
      })
    }
  }
}
</script>

<style scoped lang="stylus">
.badge
  font-size 0.875rem

.tags
  .position-absolute
    top 0.25rem
    right 20px

.steps
  >>> .tabs
    .nav
      border none 0
      .nav-item
        width 8rem
        text-align center
        margin-bottom 1rem
        margin-right 1rem

        border solid 1px #ccc

        .current
          font-weight 600

        a
          border 0
          color #ccc
          position relative

          &.active
            color #333
            background-color transparent

            &:before
              content ''
              position absolute
              top 2.5rem
              width 100%
              height 4px
              left 0
              background-color #007bff

          &.active:after
            // background-color #999
            // border 1px solid #999

        &.finished
          background-color #eee
          a
            color #666
        &.current
          background-color #666
          a
            color #fff

        &.yet
          pointer-events none

        &.finished
        &.current
          border 0 none
          margin-right 24px
          position relative

          &:after
            content ''
            position absolute
            border-width 20px 0 20px 12px
            border-style solid

            width 0
            height 0
            top 0
            right -12px

            z-index 1

        &.finished:after
          border-color transparent transparent transparent #eee
        &.current:after
          border-color transparent transparent transparent #666

  form
    .form-group
      margin-bottom 0
      >>> label
        margin-bottom 0

      .form-control-plaintext
        line-height 2

.files
  .file
    display inline-block
    padding-right 1rem
    padding-bottom 0.5rem
    word-break break-all
.status
pre.note
  background-color transparent

table.educations
table.careers
  table-layout fixed

table.messages
  width 100%
  table-layout fixed
  tr
    border-bottom 1px solid #e6e8f1
    td
      position relative
      overflow-wrap break-word
      padding-left 20px
      padding-right 20px
      p
        width calc(100% - 3rem)
        margin-bottom 0.5rem
        span.name
          font-weight 600
        span.deleted
          font-weight 200
        span.date
          margin-left 1rem
      .btn.edit
      .btn.remove
        position absolute
        color #999
        top 0.125rem
        padding 0.75rem 0.5rem
      .btn.edit
        right 2rem
      .btn.remove
        right 0.5rem

      .btn.expand
        position absolute
        color #999
        top 0.125rem
        padding 0.75rem 0.5rem
        right 1.75rem
      a.edit
        color #999
      pre.message
        background-color transparent
        cursor pointer
        line-height 1.25rem
        margin-bottom 0.5rem
        white-space pre-wrap
        height auto
        overflow auto
    &:nth-last-child(2)
      border-bottom 0 none
    &.infinite
      border-bottom 0 none
      td
        border 0 none
        background-color transparent
        padding 0

>>> .modal-dialog
  .modal-body
    form
      .form-group
        #input-startDate
          width 10rem
        #input-startTime
          width 8rem
        #input-judge.btn-group
          .btn
            padding 1rem 2rem

.btn.unclickable
  cursor default
  background-color #fff
  border-color #ed164d
  color #ed164d
  border-width 2px
  &:hover
    background-color #fff
    border-color #ed164d
    color #ed164d
    border-width 2px

  //-&.scheduled

  //-&.kept
    //-&:hover

  &.undecided
    background-color #db5f8a /*#e1ad9d*/
    color #fff
    border-width 0
    &:hover
      background-color #db5f8a /*#e1ad9d*/
      color #fff

  &.failure
    background-color #ccc
    color #fff
    border-width 0
    &:hover
      background-color #ccc
      color #fff

  &.offer
    background-color #ffa73f
    color #fff
    border-width 0
    &:hover
      background-color #ffa73f
      color #fff

  &.employ
    background-color #fe852c
    color #fff
    border-width 0
    &:hover
      background-color #fe852c
      color #fff

.form-group
  position relative

  .boilerplates.position-absolute
    top -0.125rem
    right 0
    .custom-select-sm
      height calc(1.5em + 0.5rem + 2px)
      padding-left 0.6rem
      max-width 15rem

.timeline
  .position-absolute
    top 0.25rem
    right 20px

.previewWrapper
  min-height 100px
  #previewPeopleFile
    max-height calc(100vh - 4rem - 4.75rem - 3.75rem)
    &.pdf
      height calc(100vh - 4rem - 4.75rem - 3.75rem)
    &.markdown
      height calc(100vh - 4rem - 4.75rem - 3.75rem)
      text-align left
      white-space pre
      word-wrap break-word
      overflow scroll
      border 1px solid #ccc
      padding 1rem
</style>
